import {
  AdjustmentType,
  ProductZodSchema,
  ReturnZodSchema_,
} from "@redotech/redo-model/return";
import { ReturnTotalsType } from "@redotech/redo-model/returns/return-totals/return-totals-set";
import { ReturnSummaryTotalsSchema } from "@redotech/redo-model/returns/return-totals/types";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod/v4";

const AdjustmentOverrideSchema = z.object({
  flatInPresentmentCurrency: z.number(),
  proportion: z.number(),
  type: createEnum(AdjustmentType),
});

export const getReturnTotals = {
  name: "getReturnTotals" as const,
  input: z.object({
    returnId: z.string(),
    overrides: z
      .object({
        fields: ReturnZodSchema_.partial().optional(),
        adjustmentOverrides: z.array(AdjustmentOverrideSchema).optional(),
        productOverrides: z
          .array(
            z.object({
              productObjectId: z.string(),
              adjustmentOverrides: z.array(AdjustmentOverrideSchema).optional(),
              fields: ProductZodSchema.partial(),
            }),
          )
          .optional(),
      })
      .nullish(),
  }),
  output: z.object({
    returnSummaryTotals: ReturnSummaryTotalsSchema.optional(),
    returnTotalsTypeToUse: createEnum(ReturnTotalsType).optional(),
  }),
};
